export default __webpack_public_path__ + "static/media/tax-new.5bcd1218.jpg";